(function(){
  if (typeof document === 'undefined') return;
  function init(root){
    var track = root.querySelector('.featured-slider__track');
    if(!track) return;
    var items = track.querySelectorAll('.featured-slider__item');
    if(!items.length) return;
    var prevBtn = root.querySelector('[data-featured-slider="prev"]');
    var nextBtn = root.querySelector('[data-featured-slider="next"]');
    if(!prevBtn && !nextBtn) return;

    function stepSize(){
      var first = items[0];
      var rect = first.getBoundingClientRect();
      var gap = 0;
      var cs = window.getComputedStyle(track);
      var gapStr = cs.columnGap || cs.gap || '0px';
      var parsed = parseFloat(gapStr);
      if(!isNaN(parsed)) gap = parsed;
      return rect.width + gap;
    }

    function atStart(){
      return Math.ceil(track.scrollLeft) <= 0;
    }

    function atEnd(){
      var max = track.scrollWidth - track.clientWidth;
      return Math.floor(track.scrollLeft) >= (max - 1);
    }

    function scrollByDir(dir){
      var step = stepSize();
      if(step <= 0) return;
      if(dir > 0 && atEnd()){
        track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      if(dir < 0 && atStart()){
        var max = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: max, behavior: 'smooth' });
        return;
      }
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    if(prevBtn){
      prevBtn.addEventListener('click', function(e){ e.preventDefault(); scrollByDir(-1); });
    }
    if(nextBtn){
      nextBtn.addEventListener('click', function(e){ e.preventDefault(); scrollByDir(1); });
    }

    // Recompute on resize (no-op here since we compute lazily each click)
  }

  function run(){
    var roots = document.querySelectorAll('.featured-slider');
    if(!roots.length) return;
    roots.forEach(init);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
